import React from "react";
import PotencyCircles from "./PotencyCircles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const dosageLevels = [
  {
    level: "Zero",
    value: "0",
    description:
      "This product should provide feelings of delight due to its deliciousness and quality. However, it should otherwise have no effect on your mood or state of mind :)",
  },
  {
    level: "Micro",
    value: "1",
    description:
      "A single serving of this product should have minimal effect on your mood or state of mind. You may still benefit from this level of potency but a body or head high is unlikely.",
  },
  {
    level: "Low",
    value: "2",
    description:
      "A single serving of this product has some effect on your mind and state of mind. You may experience a slightly elevated sense of how your body and mind feel.",
  },
  {
    level: "Mid",
    value: "3",
    description:
      "A single serving of this product has an effect on your mind and state of mind. The effects will likely last from two to four hours depending on other factors like your body mass or previous experiences with this product.",
  },
  {
    level: "High",
    value: "4",
    description:
      "A single serving of this product produces strong effects on your mind and state of mind. You may feel different sensations in your head and how key ingredients interact with your baseline state.",
  },
  {
    level: "Macro",
    value: "5",
    description:
      "A single serving of this product has both a very strong effect on how you feel and perceive your surroundings plus a rapid onset of these effects. We always recommend that you consume this product responsibly.",
  },
];

const PotencyCardList = () => {
  return (
    <details css={styles.details}>
      <summary css={styles.summary}>
        <div>
          <p>Potency Index</p>
          <p style={{ fontSize: ".8rem", color: "gray", fontWeight: 500 }}>What the potency ratings mean</p>
        </div>
        <ExpandMoreIcon css={styles.icon} />
      </summary>
      <div css={{ width: "100%", margin: "0 auto" }}>
        <div style={{ height: 20 }} />
        <div style={styles.container}>
          {dosageLevels.map((dosage, index) => (
            <div key={index} style={styles.card}>
              <div style={{ display: "flex", flexDirection: "row", marginBottom: 5 }}>
                <div style={{ fontWeight: 600, width: 50, textAlign: "left" }}>{dosage?.level}</div>
                <PotencyCircles value={parseInt(dosage.value)} containerStyles={{ marginLeft: 5 }} />
              </div>
              <p style={styles.descriptionText}>{dosage.description}</p>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 20, fontSize: "1.1rem", padding: "0px 10px 10px 10px", fontWeight: 600, textAlign: "center" }}>Always consume responsibly.</div>
      </div>
    </details>
  );
};

const styles = {
  details: {
    "summary::-webkit-details-marker": {
      display: "none",
    },
    "summary::marker": {
      content: "''",
    },
    "&[open]>summary": {
      transition: "all 350ms ease-in-out",
      "svg": {
        transform: "rotate(180deg)",
      }
    }
  },
  summary: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "10px",
    color: "black",
    fontWeight: 800,
    fontSize: "1.3rem",
    [mq[1]]: {
      fontSize: "1.5rem",
    },
  },
  icon: {
    width: "24px",
    height: "24px",
    [mq[0]]: {
      width: "26px",
      height: "26px",
    },
  },
  container: {
    display: "flex",
    gap: 20,
    flexDirection: "column",
    border: " 1px solid #b3b3b3",
    borderRadius: 10,
    color: "black",
    padding: "15px 0",
  },
  card: {
    borderRadius: 10,
    padding: "7px 10px",
    fontWeight: 500,
    fontSize: "1rem",
    maxWidth: "100%",
  },
  valueText: {
    margin: "10px 0 5px 0",
    fontSize: "1.25rem",
  },
  descriptionText: {
    marginTop: 10,
    margin: 0,
    fontSize: "0.9rem",
    width: "100%"
  },
};

export default PotencyCardList;
